<template>
    <div :key="componentKey">
        <a-upload-dragger :remove="handleRemove" :fileList="fileList" :beforeUpload="beforeUpload" :multiple="false">
            <span class="fa fa-file-import" style="font: 20pt" />
            <p class="ant-upload-text">
              Click or drag file to this area to upload
            </p>
        </a-upload-dragger>
        <div>
            <li v-for="msg in msgs">
                <ul>{{msg.join(', ')}}</ul>
            </li>
            <table v-if="parsed" style="width: 100%;" class="table table-responsive" :key="tableComponent">
                <thead>
                    <tr>
                        <th v-for="header in headers">{{ header }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, rowKey) in contents"
                        v-bind:key="'row-'+rowKey">
                            <td v-for="header in headers">
                                <span>{{row[header]}}</span>
                            </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { head, result } from 'lodash';
import Papa from 'papaparse';

    export default{
        data(){
            return {
                fileList: [],
                contents: [],
                parsed: false,
                componentKey: 0,
                tableComponent:0,
                msgs: [],
                headers: [],
            }
        },
        watch: {
            contents: {
                handler(newContent){
                    console.log(newContent);
                },
                immediate: true
            }
        },
        methods: {
            validateRow(item){  
                let message = []
                let error = 0

                if(item.hasOwnProperty('name')){
                    if(item.name === "" || item.name.endsWith(' ')){
                        message.push(`${item.name} has invalid name`)
                        error += 1
                        // return "invalid-row"
                    }
                }

                if(item.hasOwnProperty('retail_price')){
                    if(item.retail_price === "" || isNaN(parseFloat(item.retail_price)) || item.retail_price.includes(',')){
                        message.push(`${item.name} has invalid retail_price`);
                        error += 1
                    }
                }

                if(item.hasOwnProperty('ordering_cost')){
                    if(item.ordering_cost === "" || isNaN(parseFloat(item.ordering_cost)) || item.ordering_cost.includes(',')){
                        message.push(`${item.name} has invalid ordering_cost`);
                        error += 1
                    }
                }

                if(item.hasOwnProperty('landed_cost')){
                    if(item.landed_cost === "" || isNaN(parseFloat(item.landed_cost)) || item.landed_cost.includes(',')){
                        message.push(`${item.name} has invalid landed_cost`);
                        error += 1
                    }
                }

                if(item.hasOwnProperty('site_codes')){
                    if(item.site_codes === ""){
                        message.push(`${item.name} has invalid site_codes`);
                        error += 1

                    }
                }

                if(item.hasOwnProperty('alternate_barcodes')){
                    if(item.alternate_barcodes === ""){
                        message.push(`${item.name} has invalid alternate_barcodes`);
                        error += 1

                    }
                }

                if(item.hasOwnProperty('vat_type')){
                    if(!item.vat_type.includes('V','N')){
                        message.push(`${item.name} has invalid vat_type`);
                        error += 1

                    }
                }
                
                console.log(error)
                if(error > 0){
                    this.msgs.push(message)
                    return "invalid-row"
                }
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
                this.componentKey++;
                this.tableComponent++;
            },
            beforeUpload(file) {
                this.fileList = [];
                this.fileList = [...this.fileList, file];
                this.parseFile();
            },
            async parseFile(){
                await Papa.parse( this.fileList[0], {
                    header: true,
                    skipEmptyLines: true,
                    // step: (result, parser) => {
                    //     // let res = this.validateRow(result.data)
                    //     // if(res == "invalid-row"){
                    //     //     console.log("awit")
                    //     //     this.contents.push(result.data)
                    //     // }else{
                    //     //     console.log("tiwa")
                    //     // }
                    //     // return result
                    // },
                    complete: (results) => {
                        results.data.forEach((element) => {
                            let res = this.validateRow(element)
                            if(res =='invalid-row'){
                                this.contents.push(element)
                            }
                        })
                        console.log("Complete Parse",results,results.meta.fields)
                        this.headers = results.meta.fields
                        this.tableComponent += 1;
                        this.parsed =true
                    }
                } );
            },
        },
    }

</script>
<style>
    .invalid-row{
        background-color: red;
    }
</style>